import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataExternalApi, NodeDataUpdateExternalApi } from '@onefootprint/request-types/dashboard';
import { Divider, Shimmer } from '@onefootprint/ui';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import useStore from '../../hooks/use-store';
import BaseNode from '../base-node';
import ExternalApiContent from './components/external-api-content';
import useProxyConfigs from './hooks/use-proxy-configs';
type ExternalApiNodeProps = NodeProps<ApiNodeDataExternalApi> & {
  onSubmit?: (data: NodeDataUpdateExternalApi) => void; // For storybook testing
};
export const ExternalApiNode = t0 => {
  const $ = _c(18);
  let node;
  let onSubmit;
  if ($[0] !== t0) {
    ({
      onSubmit,
      ...node
    } = t0);
    $[0] = t0;
    $[1] = node;
    $[2] = onSubmit;
  } else {
    node = $[1];
    onSubmit = $[2];
  }
  const {
    data: t1
  } = useStore();
  const {
    canEdit,
    traceEntries
  } = t1;
  const {
    isLoading,
    proxyConfig,
    sandboxProxyConfig
  } = useProxyConfigs(node.data.source);
  let t2;
  if ($[3] !== node.id || $[4] !== traceEntries) {
    t2 = traceEntries?.find(entry => node.id === entry.decisionNodeId);
    $[3] = node.id;
    $[4] = traceEntries;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const traceEntry = t2;
  let t3;
  if ($[6] !== canEdit || $[7] !== isLoading || $[8] !== node || $[9] !== onSubmit || $[10] !== proxyConfig || $[11] !== sandboxProxyConfig || $[12] !== traceEntry) {
    t3 = {
      size: "lg",
      form: "external-api-form",
      render: t4 => {
        const {
          mutation
        } = t4;
        return <>{isLoading ? <Loading /> : <ExternalApiContent node={node} mutation={mutation} canEdit={canEdit} traceEntry={traceEntry} proxyConfig={proxyConfig} sandboxProxyConfig={sandboxProxyConfig} onSubmit={onSubmit} />}</>;
      }
    };
    $[6] = canEdit;
    $[7] = isLoading;
    $[8] = node;
    $[9] = onSubmit;
    $[10] = proxyConfig;
    $[11] = sandboxProxyConfig;
    $[12] = traceEntry;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== node.data || $[15] !== node.id || $[16] !== t3) {
    t4 = <BaseNode nodeId={node.id} data={node.data} sidebar={t3} />;
    $[14] = node.data;
    $[15] = node.id;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
};
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-4 pb-4"><div className="flex flex-row justify-between w-full items-center"><Shimmer width="76px" height="20px" /><Shimmer width="50%" height="32px" /></div><Divider /><Shimmer width="100%" height="250px" /><Shimmer width="100%" height="424px" /><Shimmer width="100%" height="363px" /><Shimmer width="100%" height="266px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ExternalApiNode;